<template>
	<sym-icon name="resize-window" class="resize-corner"></sym-icon>
</template>

<script setup lang="ts">
import SymIcon from "@fd/helpers/SymIcon.vue";
</script>

<style>
.resize-corner {
	position: absolute;
	width: 18px;
	height: 18px;
	right: 0;
	bottom: 0;
	cursor: nwse-resize;
	opacity: .2;
}
</style>